<div
  [fxLayout]="(breakpoint | async) ? 'column' : 'row'"
  [fxLayoutAlign]="rowFxLayoutAlign"
  [fxLayoutGap]="fxLayoutGap"
>
  <div
    [fxFlex]="(breakpoint | async) ? '1 0 100%' : column1FxFlex"
    [fxLayout]="(breakpoint | async) ? 'row' : 'column'"
    [fxLayoutAlign]="column1FxLayoutAlign"
    fxFlexFill
    [fxFlexOrder]="revertOrderOnBreakpoint && (breakpoint | async) ? '1' : '0'"
  >
    <ng-content select="[col-1]"></ng-content>
  </div>

  <div
    [fxFlex]="(breakpoint | async) ? '1 0 100%' : column2FxFlex"
    [fxLayout]="(breakpoint | async) ? 'row' : 'column'"
    [fxLayoutAlign]="column2FxLayoutAlign"
    fxFlexFill
  >
    <ng-content select="[col-2]"></ng-content>
  </div>
</div>
